import { useEffect, useRef } from "react";

function Tooltip({ children, text, placement = "top" }) {
    const tooltipRef = useRef(null);
    const tooltipInstance = useRef(null);

    useEffect(() => {
        const el = tooltipRef.current;
        if (!el || !window.bootstrap?.Tooltip) return;


        tooltipInstance.current = new window.bootstrap.Tooltip(el, {
            title: text,
            placement,
            trigger: "manual",
        });

        const show = () => tooltipInstance.current.show();
        const hide = () => tooltipInstance.current.hide();

        el.addEventListener("mouseenter", show);
        el.addEventListener("mouseleave", hide);
        el.addEventListener("focus", show);
        el.addEventListener("blur", hide);

        el.addEventListener("click", () => {
            tooltipInstance.current.hide();
        });

        return () => {
            el.removeEventListener("mouseenter", show);
            el.removeEventListener("mouseleave", hide);
            el.removeEventListener("focus", show);
            el.removeEventListener("blur", hide);
            tooltipInstance.current.dispose();
        };
    }, [text, placement]);

    return (
        <span ref={tooltipRef} className="d-inline-block" tabIndex="0">
            {children}
        </span>
    );
}

export default Tooltip;
